import jQuery from "jquery";

import addScrollReveal from "./scrollreveal";
import imageLightbox from "./gallery";
import initTabs from "./tabs";
import { imagesSlider } from "./sliders";
import { openBuilding } from "./apartment-functions";
import initObjectsTable from "./datatables";
import tippy from "tippy.js";
import initContentTabs from "./content-tabs";
import initCookie from "./cookie";
import triggerPopUp from "./auto-popup";
import setKorpusHashes from "./korpus-links";

addScrollReveal();
imageLightbox();
initContentTabs();
imagesSlider();
openBuilding();
initObjectsTable();
initCookie();
triggerPopUp();
setKorpusHashes();

const TippyInstance = document.querySelectorAll("[data-tippy-content]");
tippy(TippyInstance, {
  placement: "top",
  delay: 0,
});

const observer = new IntersectionObserver(function (entries) {
  if (!entries[0].isIntersecting) {
    document.body.classList.add("header-scrolled");
  } else {
    document.body.classList.remove("header-scrolled");
  }
});

// observer.observe(document.querySelector(".observe"));
observer.observe(document.querySelector(".header-observer"));

function openMenu() {
  function init() {
    const btn = document.querySelector(".menu-btn");
    const hamburger = document.querySelector(".hamburger");
    const menu = document.querySelector(".mobile-menu");

    btn.addEventListener("click", () => {
      hamburger.classList.toggle("is-active");
      menu.classList.toggle("is-open");
      document.body.classList.toggle("mobile-menu-open");
    });

    const items = document.querySelectorAll(".primary-nav-mobile a");

    items.forEach((item) => {
      item.addEventListener("click", () => {
        btn.click();
      });
    });
  }

  const isPresent = document.getElementsByClassName("hamburger");
  if (isPresent.length > 0) {
    init();
  }
}

openMenu();

jQuery(document).ready(function ($) {
  if ($("body").hasClass("tax-object_building_section")) {
    initTabs();

    function removeLoader() {
      $(".custom-loader").fadeOut(200, function () {
        $(".custom-loader").remove();
      });
    }

    setTimeout(removeLoader, 400); // wait for page load PLUS one seconds.
  }
});
